const {BASE_URL} = require('./client');

const GET_QUERIES = BASE_URL + '/api/queries/get';
const SET_MODE = BASE_URL + '/api/queries/setMode';
const RESOLVE_QUERY = BASE_URL + '/api/queries/resolve';
const UPDATE_QUERY = BASE_URL + '/api/queries/message';
module.exports = {
    GET_QUERIES,
    SET_MODE,
    RESOLVE_QUERY,
    UPDATE_QUERY,
}